<template>
  <div id="app-foot">
    <div class="foot-top">
      <div class="top-box">
        <div class="top-l">
          <span @click="gotoPartners">合作伙伴</span>
          <!-- <span>媒体伙伴</span> -->
          <span @click="gotoInstitution">研究机构</span>
          <span @click="gotoHospital">定点机构</span>
        </div>
        <div class="top-r">
<!--          <router-link to="/unitLogin">-->
          <a href="http://manage.eyelovechina.com/unit/#/login" target="_blank">
            <button>执行机构登录</button>
          </a>
<!--          </router-link>-->
          <!-- <router-link to="/login">
            <button>基金会登录</button>
          </router-link>-->
        </div>
      </div>
    </div>
    <div class="foot-bottom">
      <div class="bottom-box">
        <div class="bottom-l">
          <div class="ul-box" v-for="(item,index) in channelData" :key="index">
            <span @click="getStyle(item)" @mouseenter="navBarShow(item)">{{item.channel_title}}</span>
            <ul>
              <li
                v-for="(item1,index1) in item.children"
                :key="index1"
                @click="goto(item,item1)"
              >{{item1.channel_title}}</li>
            </ul>
          </div>
        </div>
        <div class="bottom-r">
          <ul>

            <li>
              <img src="../../assets/images/dyh.jpg" alt />
              <p>微信公众号</p>
            </li>
            <li>
              <img src="../../assets/images/sina_qrcode.jpg" alt />
              <p>微博</p>
            </li>
            <li>
              <img src="../../assets/images/tiktok_qrcode.jpg" alt />
              <p>抖音</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-box">
        <div class="f-top">
          <div class="top-l">
            <span>公益捐赠帐户名称 / {{webInfo.account}}</span>
            <span>开户行 / {{webInfo.bank_name}}</span>
            <span>账号 / {{webInfo.bankid}}</span>
          </div>
          <p>技术支持 / 普益云科技</p>
        </div>
        <div class="f-top">
          <div class="top-l">
            <span v-if="webInfo.website_phone">联系电话 / {{webInfo.website_phone}}</span>
            <span v-if="webInfo.fax">传真 / {{webInfo.fax}}</span>
            <span v-if="webInfo.email">电子邮件 / {{webInfo.email}}</span>
            <span>湘公网安备 {{webInfo.dxicp}}</span>
          </div>
          <p>
            网站备案号/
            <a
              href="http://www.beian.miit.gov.cn"
              target="_blank"
              style="color:#707278"
            >{{webInfo.icp}}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      newPath: {},
      liStyle: 1,
      webInfo: {}, //网站信息
      channelData: []
    };
  },
  methods: {
    //合作伙伴
    gotoPartners() {
      this.$router.push({
        path: "/orgList"
      });
    },
    //研究机构
    gotoInstitution() {
      this.$router.push({
        path: "/orgLists"
      });
    },
    //定点执行机构
    gotoHospital() {
      this.$router.push({
        path: "/unitList"
      });
    },

    getStyle(item) {
      //点击一级导航

      this.liStyle = item.id;
      let index = item.cat_type;
      if (index == 4) {
        //新窗口打开外部链接
        window.open(item.channel_url);
      } else {
        this.$router.push(this.newPath);
        sessionStorage.setItem("bread1", item.channel_title);
        sessionStorage.setItem("index", item.id);
      }
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    getFootChannel() {
      //获取底部导航信息
      this.$db
        .post(this.$db.config.getChannelDataUrl, { channel_type: 2 })
        .then(res => {
          if (res.code == 200) {
            this.channelData = res.data;
            let info = JSON.stringify(res.data);
            sessionStorage.setItem("channelFootList", info);
          }
        });
    },
    goto(item, item1) {
      let path = {};
      let index = item.cat_type;
      let type = item.template;

      if (index != 4) {
        //除外部链接
        if (index == 5) {
          //内部链接
          if (type == 1) {
            //首页
            delete path.query;
            path.path = "/";
          } else if (type == 5) {
            //救助申请
            pth.path = "/applyIndex";
          } else {
            //组装路由地址
            path.query = {};
            path.path = "/pubIndex";
            path.query.cid = item.id;
          }
        } else {
          //组装路由地址
          path.query = {};
          path.path = "/pubIndex";
          path.query.cid = item.id;
        }
        sessionStorage.setItem("bread1", item.channel_title);
        sessionStorage.setItem("index", item.id);
      }

      if (item1.cat_type == 4) {
        return window.open(item1.channel_url);
      } else {
        path.query.tabid = item1.id;
        this.$router.push(path);
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    },
    navBarShow(item) {
      //鼠标移至一级导航
      let index = item.cat_type;
      let type = item.template;

      // if(item.cat_type == 1|| item.cat_type == 3){//只有一级导航为列表才显示二级导航
      //   this.childShow = true
      // }else{
      //   this.childShow = false
      // }

      if (index != 4) {
        //除外部链接
        if (index == 5) {
          //内部链接
          if (type == 1) {
            //首页
            delete this.newPath.query;
            this.newPath.path = "/";
          } else if (type == 5) {
            //救助申请
            this.newPath.path = "/applyIndex";
          } else if (type == 6) {
            this.newPath.path = "/branchIndex";
          } else {
            //组装路由地址
            this.newPath.query = {};
            this.newPath.path = "/pubIndex";
            this.newPath.query.cid = item.id;
          }
        } else {
          //组装路由地址
          this.newPath.query = {};
          this.newPath.path = "/pubIndex";
          this.newPath.query.cid = item.id;
        }
      }

      this.childId = item.id;
    }
  },
  computed: {
    webData() {
      let info = this.$store.state.web_info;
      return info;
    }
  },

  watch: {
    "$route.query.cid": function(val) {
      this.liStyle = val;
    },
    webData: {
      handler(val) {
        if (val) {
          this.webInfo = val;
        }
      },
      immediate:true,
    }
  },
  mounted() {
    window.addEventListener("beforeunload", e => {
      sessionStorage.removeItem("channelFootList");
    });

    if (sessionStorage.getItem("channelFootList")) {
      this.channelData = JSON.parse(sessionStorage.getItem("channelFootList"));
    } else {
      this.getFootChannel();
    }
  }
};
</script>

<style lang="scss" scoped>
#app-foot {
  width: 100%;
}

.foot-top {
  width: 100%;
  height: 60px;
  background-color: #202020;
  .top-box {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .top-l {
      display: flex;
      justify-content: space-between;
      width: 450px;
      > span {
        font-size: 18px;
        color: #ffffff;
        line-height: 60px;
        cursor: pointer;
      }
    }
    .top-r {
      // display: flex;
      // justify-content: space-between;
      width: 270px;
      padding: 11px 0;
      text-align: right;
      > a {
        display: block;
        > button {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          padding: 8px 17px;
          font-size: 16px;
          color: #ffffff;
          background-color: #202020;
          border: 1px solid #535353;
          cursor: pointer;
        }
      }
    }
  }
}
.foot-bottom {
  width: 100%;
  background-color: #1b1b1b;
  .bottom-box {
    width: 1300px;
    margin: 0 auto;
    padding: 32px 0;
    display: flex;
    justify-content: space-between;
    .bottom-l {
      width: 854px;
      display: flex;
      justify-content: space-between;
      .ul-box {
        height: 218px;
        > span {
          cursor: pointer;
          display: block;
          width: 100px;
          padding-bottom: 14px;
          font-size: 16px;
          color: #cccccc;
          background: url(../../assets/images/sp_bg.png) left bottom no-repeat;
          margin-bottom: 20px;
        }
        > ul {
          > li {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 83px;
            list-style: none;
            font-size: 14px;
            color: #707278;
            margin-bottom: 12px;
            cursor: pointer;
            &:hover {
              color: #fff;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .bottom-r {
      padding-top: 42px;
      margin-left: 35px;
      > ul {
        width: 420px;
        display: flex;
        justify-content: flex-end;
        > li {
          list-style: none;
          margin-right: 10px;
          text-align: center;
          > img {
            width: 110px;
            height: 110px;
          }
          > p {
            font-size: 14px;
            color: #999999;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
.footer {
  width: 100%;
  background-color: #1b1b1b;
  border-top: 1px solid #2b2b2b;
  .footer-box {
    width: 1300px;
    margin: 0 auto;
    padding: 26px 0;
    .f-top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
      .top-l {
        > span {
          font-size: 14px;
          color: #707278;
          padding: 0 20px;
          border-right: 1px solid #707278;
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
      > p {
        font-size: 14px;
        color: #707278;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/foot.vue